export function priceFormatter(price: number, currency: string) {
  const currencyUpperCase = currency.toUpperCase();

  if (currencyUpperCase === 'HRK') {
    return `+ ${price.toFixed(2)} Kn`;
  }
  if (currencyUpperCase === 'EUR') {
    return `+ ${price.toFixed(2)} €`;
  }
  if (currencyUpperCase === 'USD') {
    return `+ $${price.toFixed(2)}`;
  }
  if (currencyUpperCase === 'RSD') {
    return `+ ${price.toFixed(2)} rsd`;
  }
  if (currencyUpperCase === 'PLN') {
    return `+ ${price.toFixed(2)} zł`;
  }
}
